// Рантайм-конфиг фронта. baseUrl api-server (HTTPS) — из window-инъекции (`window.__APP_CONFIG__`,
// которую отдаёт api-server в index.html) или из текущего origin по умолчанию. Никакой сети тут нет —
// просто чтение конфигурации окружения.

export interface AppConfig {
  /** Origin api-server (HTTPS). WSS выводит client-transport из него. */
  baseUrl: string
  /** Запасные WS-эндпоинты (мульти-edge): клиент сам переключается, пока не заработает. */
  wsFallbackUrls: string[]
}

interface WindowWithConfig {
  __APP_CONFIG__?: Partial<AppConfig>
}

/**
 * Известные edge-пары прод-стенда (мульти-edge, 2026-07-06): DPI провайдера душит WS к одному edge
 * при живом HTTP (client-diag 2026-07-05) — второй туннель на другом IP даёт обходной WS-путь.
 * С какого домена приложение открыто — тот primary; парный — фолбэк. Прочие origin (dev) — без фолбэка.
 */
const EDGE_PAIRS: Record<string, string[]> = {
  'telechat.ru.tuna.am': ['wss://telechat.nl.tuna.am/ws'],
  'telechat.nl.tuna.am': ['wss://telechat.ru.tuna.am/ws'],
}

/** Прочитать конфиг приложения (origin api-server + WS-фолбэки). По умолчанию — текущий origin. */
export function readAppConfig(): AppConfig {
  const injected =
    typeof window !== 'undefined' ? (window as unknown as WindowWithConfig).__APP_CONFIG__ : undefined
  const origin =
    typeof window !== 'undefined' && typeof window.location !== 'undefined'
      ? window.location.origin
      : 'https://localhost'
  const baseUrl = injected?.baseUrl ?? origin
  const host = baseUrl.replace(/^https?:\/\//, '').replace(/\/.*$/, '')
  return {
    baseUrl,
    wsFallbackUrls: injected?.wsFallbackUrls ?? EDGE_PAIRS[host] ?? [],
  }
}
